import type { CookieAuthActions } from "./types";
import {
  type AuthError,
  type AuthUiStatus,
  useAuthStatus,
  useAuthStore,
  useAuthUser,
} from "../auth-store";
import { useCookieAuthStore } from "./store";

export interface UseCookieAuthResult extends CookieAuthActions {
  status: AuthUiStatus;
  user: ReturnType<typeof useAuthUser>;
  token: null;
  isLoading: boolean;
  error: AuthError | null;
}

export function useCookieAuth(): UseCookieAuthResult {
  const user = useAuthUser();
  const status = useAuthStatus();
  const isLoading = useAuthStore((s) => s.isInitializing || s.isAuthenticating);
  const error = useAuthStore((s) => s.error);

  const signIn = useCookieAuthStore((s) => s.signIn);
  const signUp = useCookieAuthStore((s) => s.signUp);
  const signInAnonymous = useCookieAuthStore((s) => s.signInAnonymous);
  const signOut = useCookieAuthStore((s) => s.signOut);
  const refreshSession = useCookieAuthStore((s) => s.refreshSession);

  return {
    status,
    user,
    token: null,
    isLoading,
    error,
    signIn,
    signUp,
    signInAnonymous,
    signOut,
    refreshSession,
  };
}
